<template>
  <div class="tab-pane fade active" id="device-error-statistic" role="tabpanel"
    aria-labelledby="device-error-statistic-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-3">
          <span>風景區</span>
          <select class="form-control" v-model="selectScenicAreaId">
            <option value="-1">請選擇</option>
            <option v-for="(list, index) in scenicAreaList" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <span>設備種類</span>
          <select class="form-control" v-model.number="selectDeviceTypeList" multiple id="selectDeviceTypeStatistic">
            <option value="-1">請選擇(全部)</option>
            <option v-for="(list, index) in deviceTypeList" :key="index" :value="list.enumType">{{ list.description }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <span>資料開始時間</span>
          <datetime input-class="form-control" type="date" format="yyyy-MM-dd" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="startTime">
          </datetime>
        </div>

        <div class="col-md-3">
          <span>資料結束時間</span>
          <datetime input-class="form-control" type="date" format="yyyy-MM-dd" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="endTime">
          </datetime>
        </div>
        <div class="col-md-3 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
            @click="queryDeviceErrorStatistic" :disabled="isWaiting">
            <i class="fas fa-search"></i>查詢
          </button>
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaiting">
            <i class="fas fa-share"></i>匯出
          </button>
        </div>
      </form>
      <h1 style="margin-top: 0px;">設備事件統計</h1>
    </div>
    <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
      <div class="col">
        <div class="card card-clean h-100">
          <div class="bd-example">
            <table id="deviceErrorStatisitcTable" :class="tableStyle">
              <thead :class="tableThStyle" class="table-dark">
                <tr>
                  <th scope="col">風景區</th>
                  <th scope="col">設備種類</th>
                  <th scope="col">數量</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in devicesStatisticList" :key="index" :class="tableCenterStyle">
                  <td>{{ item.scenicAreaName }}</td>
                  <td>{{ getDeviceTypeName(item.deviceType) }}</td>
                  <td>{{ item.count }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div id="chart" class="mt-5"></div>
  </div>
</template>
    
<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import { getDeviceErrorStatisticData } from '../../api/eastCoastDataApi/device/DeviceErrorApi'
import exportCSV from '../../utils/exportCSV'
import ApexCharts from 'apexcharts';
export default {
  name: "Home",
  data() {
    return {
      Const: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      chart: null,
      selectScenicAreaId: -1,
      // selectPublicPlaceId: -1,
      deviceTypeList: [],
      selectDeviceTypeList: [],
      devicesStatisticList: [],
      deviceErrorTypeEnum: CONST.DEVICE_ERROR_TYPE,
      startTime: moment().startOf('day').format(),
      endTime: moment().endOf('day').format(),
      isWaiting: false
    };
  },
  computed: {
    ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    maxSelectTime() {
      return moment()
        .startOf('m')
        .toISOString()
    },
  },
  watch: {
    selectDeviceTypeList() {
      if(this.selectDeviceTypeList[0] === -1 && this.selectDeviceTypeList.length === 1) {
        $('#selectDeviceTypeStatistic').selectpicker('selectAll');
      }
    }
  },
  methods: {
    initTable: function () {
      this.table = $("#deviceErrorStatisitcTable").DataTable({
        aoColumns: [
          ...new Array($("#deviceErrorStatisitcTable th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
    async queryDeviceErrorStatistic() {
      this.isWaiting = true;
      let condition = {
        "areaId": this.selectScenicAreaId == -1 ? null : this.selectScenicAreaId,
        "deviceType": this.selectDeviceTypeList.includes(-1) ? [] : this.selectDeviceTypeList,
        "stTime": moment(this.startTime).startOf("day").format(),
        "endTime": moment(this.endTime).endOf("day").format()
      }
      //debugger;
      let response = await getDeviceErrorStatisticData(condition)
      if (response.status) {
        //console.log(response.data)
        this.devicesStatisticList = response.data
        this.updateTable()
      }
      else {
        console.log('getDeviceErrorStatisticData fail');
      }

      this.drawChart(this.devicesStatisticList);
      this.isWaiting = false;
    },
    drawChart(data) {
      let vm = this;
      // 處理數據以適應 ApexCharts 格式
      let categories = [...new Set(data.map(item => item.scenicAreaName))];
      let seriesData = [];

      this.deviceTypeList.forEach(item => {
        seriesData.push({
          name: item.description,
          data: new Array(categories.length).fill(0)
        })
      })

      data.forEach(item => {
        let index = categories.findIndex((item2) => item2 == item.scenicAreaName);
        let seriesItem = seriesData.find((item2) => item2.name == vm.getDeviceTypeName(item.deviceType));
        seriesItem.data[index] = item.count;
      });

      var options = {
        colors:CONST.APEXCHART_COLOR.DEVICE_ERROR_STATISTIC,
        chart: {
          type: 'bar',
          height: 350,
          stacked: true
        },
        plotOptions: {
          bar: {
            horizontal: false
          },
        },
        series: seriesData,
        xaxis: {
          categories: categories
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40
        }
      };
      if (this.chart != null) {
        this.chart.destroy();
      }
      this.chart = new ApexCharts(document.querySelector("#chart"), options);
      this.chart.render();
    },
    async queryCSV() {
      this.isWaiting = true
      if (Utils.isEmptyObject(this.devicesStatisticList)) {
        alert('請先查詢再匯出')
        this.isWaiting = false
        return
      }

      const csvContent = [[ '風景區','設備種類', '數量']]
      let vm = this
      this.devicesStatisticList.forEach(item => {
        const row = []
        row.push(item.scenicAreaName)
        row.push(this.getDeviceTypeName(item.deviceType))
        row.push(item.count)

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_設備事件統計.csv`
      exportCSV.genCSVFile(csvContent, fileName)
      this.isWaiting = false
    },
    getscenicAreaIdFromName(name) {
      // device 沒有 scenicAreaId
      const target = this.scenicAreaList.find(area => {
        return area.name === name
      })

      return target ? target.id : ''
    },
    getDeviceTypeName: function (deviceType) {

      const foundObject = this.deviceTypeList.find(item => item.enumType.toUpperCase() === deviceType.toUpperCase());

      if (foundObject) {
        return foundObject.description;
      }
      else {
        return 'UnknownType';
      }
    }
  },
  async mounted() {
    this.updateTable()
    await this.$store.dispatch('deviceApi/getDevcieType')
    this.deviceTypeList = this.$store.getters['deviceApi/getDeviceType']
  

    setTimeout(() => {
      $('#selectDeviceTypeStatistic').selectpicker({
        noneSelectedText: '請選擇'
      })
    }, 100);
    // $('#selectDeviceTypeStatistic').selectpicker({
    //     noneSelectedText: '請選擇1'
    // })
  },
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th{width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>